import * as requests from '@cbgms/api/modules/themes/requests'
import { IResponse, POSTThemeBody, POSTThemeLogo, PUTThemeBody } from '@cbgms/api'
import { IPaginatedRequest } from '@cbgms/api/request'

import * as types from './types'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const listThemes = (params: IPaginatedRequest) => ({
  type: [types.GET_THEMES, types.GET_THEMES_SUCCESS, types.GET_THEMES_FAILED],
  payload: {
    api: 'support',
    request: requests.listThemes(params)
  }
})

export const getTheme = (ThemeUUID: string) => ({
  type: [types.GET_THEME, types.GET_THEME_SUCCESS, types.GET_THEME_FAILED],
  payload: {
    api: 'support',
    request: requests.getThemeById(ThemeUUID)
  }
})

export const createTheme = (data: POSTThemeBody) =>
  AsyncAction<IResponse<{ UUID: string }>>({
    type: [types.CREATE_THEME, types.CREATE_THEME_SUCCESS, types.CREATE_THEME_FAILED],
    payload: {
      api: 'support',
      request: requests.createTheme(data)
    }
  })

export const updateTheme = (ThemeUUID: string, data: PUTThemeBody) =>
  AsyncAction<IResponse<{ UUID: string }>>({
    type: [types.UPDATE_THEME, types.UPDATE_THEME_SUCCESS, types.UPDATE_THEME_FAILED],
    payload: {
      api: 'support',
      request: requests.updateThemeById(ThemeUUID, data)
    }
  })

export const deleteTheme = (ThemeUUID: string, dryRun: boolean) => ({
  type: [types.DELETE_THEME, types.DELETE_THEME_SUCCESS, types.DELETE_THEME_FAILED],
  payload: {
    api: 'support',
    request: requests.deleteTheme(ThemeUUID, dryRun)
  }
})

export const resetTheme = () => ({
  type: types.RESET_THEME_STATE
})

export const uploadImage = (file: File) =>
  AsyncAction<POSTThemeLogo>({
    type: [types.FILEUPLOAD, types.FILEUPLOAD_SUCCESS, types.FILEUPLOAD_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'POST',
        url: `/modules/media/images/themes/${file.name}`,
        data: file
      }
    }
  })
